import { ArrowRightOutlined, CheckOutlined } from '@ant-design/icons';
import { Button, Card, DatePicker, Input, message, Modal, Popover, Select, Space, Spin, Typography } from 'antd';
import { Grid, SearchPanel, Table, TableHeaderRow, Toolbar, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedFiltering, SearchState } from '@devexpress/dx-react-grid';
import React, {useEffect, useMemo, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import _ from 'lodash';
import { actions } from './WorkOrderReference.redux';
import apiInstance from '@/api';
import { getTableColumnExtensions } from '@/lib/reactiveGridTableMethods'
import LoadingCover from '@/components/LoadingCover/LoadingCover';
// import { actions as serialNumActions } from './WorkOrderMultiSerialNumber/WorkOrderSerialNumber.redux';
// import StageCompleteSerialNumberList from './WorkOrderMultiSerialNumber/StageCompleteSerialNumberList';
// import StageInProcessSerialNumberList from './WorkOrderMultiSerialNumber/StageInProcessSerialNumberList';
import { teamMemberCheck } from '../WorkOrderHelperMethods';
import { useParams } from 'react-router-dom';
import WorkOrderSNUpdateModal from './WorkOrderMultiSerialNumber/WorkOrderSNUpdateModal';
//import CopyTableDataToClipboard from 'components/CopyTableDataToClipboard/copyTableDataToClipboard';
//import { modifyTableData } from 'components/CopyTableDataToClipboard/modifyTableData';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('en');
const { Option, OptGroup } = Select;

// NOTE FOR APT: commented out alot of features that they do not currently need. No use case for SNs, they dont assign users to projects that will disable/lock next route stages.
const stagesTableColumns = [
	{
		title: 'Op #',
		name: 'OpNum', //SeqNum
		width: '75px',
	},
	{
		title: 'No.',
		name: 'RouteName',
		width: '150px',
	},
	{
		title: 'Rev',
		name: 'Revision',
		width: '50px',
	},
	{
		title: 'Desc',
		name: 'Description',
		width: '200px',
	},
	{
		title: 'Print Desc',
		name: 'PrintedDescription',
		width: '260px',
	},
	{
		title: 'Status',
		name: 'Status',
		width: '150px',
	},
	// {
	// 	title: 'Current Assignee',
	// 	name: 'CurrentAsigneeName',
	// 	width: '275px',
	// },
	{
		title: 'Line Notes',
		name: 'LineNotes',
		width: '220px',
	},
	{
		title: 'Data as Needed',
		name: 'DataAsNeeded',
		width: '220px',
	},
	{
		title: 'Start Date',
		name: 'PlannedStartDate',
		width: '150px',
	},
	{
		title: 'Due Date',
		name: 'PlannedDueDate',
		width: '150px',
	},
	{
		title: 'Attachment',
		name: 'Attachment',
		width: '120px',
	},
	{
		title: 'Attachment Link',
		name: 'UploadedAttachment',
	},
];

const statusList = [
	{ value: 'Planned', status:'Planned' },
	{ value: 'Partial', status: 'Partial' },
	{ value: 'Hold', status:'Hold' },
	{ value: 'Waived', status:'Waived' },
	{ value: 'Complete', status:'Complete' },
];

const WorkOrderStagesTable = () => {
    const dispatch       = useDispatch(),
		  params         = useParams(),
		  docNum         = params.docNum,
		  loading        = useSelector(state => state.workOrderReference.stagesLoading),
		  stageSyncing   = useSelector(state => state.workOrderReference.stagesStatusSyncing),
		  saving         = useSelector(state => state.workOrderReference.savingChanges),
          stagePage      = useSelector(state => state.workOrderReference.stagePage),
		  stageLimit     = useSelector(state => state.workOrderReference.stageLimit),
		  searchString   = useSelector(state => state.workOrderReference.stageSearchString),
		  stagesList     = useSelector(state => state.workOrderReference.stagesList),
		  rowChangesList = useSelector(state => state.workOrderReference.rowChangesList),
		  loggedEmpId    = useSelector(state => state.workOrderReference.loggedEmpId),
		  employeeList   = useSelector(state => state.workOrderReference.employeeList),
		  teamsList      = useSelector(state => state.workOrderReference.teamsList),
		  isSerialized   = useSelector(state => state.workOrderReference.workOrderHeader.IsSerial) === 'TRUE',
		  loadingWOStage = useSelector(state => state.workOrderSerialNum.loadingWOStage),
		  snInProcessList = useSelector(state => state.workOrderSerialNum.snInProcessList);

	/**
	 * We only need to load this when the component loads, as the employee list 
	 * will not change as the page or work order changes
	 */
	useEffect(() => {
		dispatch(actions.loadEmployeeList());
		dispatch(actions.loadUserInfo());
	}, [ dispatch ]);


	const stagesTableColumns = useMemo(() => {
		if (!isSerialized) {
			return baseStagesTableColumns;
		}
		const snColumns = [
			{ title: 'In Process Qty', name: 'RouteReadyForAssignment', width: '100px' },
			{ title: 'Update SN',      name: 'UpdateSN',                width: '75px'  },
			{ title: 'Completed Qty',  name: 'RouteCompleted',          width: '100px' },
		];
		return [
			...baseStagesTableColumns.slice(0, 5),
			...snColumns,
			...baseStagesTableColumns.slice(5),
		];
	}, [ isSerialized ]);

	useEffect(() => {
		if (docNum) {
			dispatch(actions.loadWorkOrderStages(docNum));
		}
	}, [ dispatch, docNum, stagePage, stageLimit, isSerialized ]);
	
	const handleClose = () => {
		dispatch(actions.setState({
			stagesStatusSyncing: false
		}));
	}
	const setSearchValue = (value) => {
		if(loading) {
			return false;
		}
		dispatch(actions.setState({ stageSearchString: value }));
	};


	const checkStageUpdate = async (docEntry, stageId) => {		
		try {
			const results = await apiInstance.get(`/workorders/workorder/${docEntry}/${stageId}/check`);

			return results.writable;
		} catch (e) {
			console.log(e);
		}
	};

	const getStageInProcessCount = (stageID) => {
		const stageInProcess = _.has(snInProcessList, stageID) ? snInProcessList[stageID] : [];
		return stageInProcess.length;
	};

	// const getStageCompletedCount = (stageID) => {
	// 	const snCompleteList = useSelector(state => state.workOrderSerialNum.snCompletedList);
	// 	const stageComplete = _.has(snCompleteList, stageID) ? snCompleteList[stageID] : [];
	// 	return stageComplete.length;
	// };

	const getNewPlannedDueDates = async (row, newDate) => {
		const docEntry = row.DocEntry,
			  stageId  = row.StageID;


		try {
			const results = await apiInstance.get(`/workorders/workorder/${docEntry}/${stageId}/calculate_dates`, {
				params: {
					newDate,
				},
			});

			return results.newRouteDates;
		} catch(e) {
			console.log(e);
		}
	};


	const commitRowChanges = async (value, columnName, rowId) => {
		const row = stagesList[rowId];

		if (columnName === 'Status') {
			const 	docEntry = row.DocEntry,
					stageId  = row.StageID;
			let writable;

			if (!isSerialized) {
				writable = await checkStageUpdate(docEntry, stageId);
				console.log(`For WO# ${docEntry}, stageId ${stageId} writable status was determined to be: ${writable}`);
				if (writable === false) {
					message.error('You cannot update the Status of this route stage because there are previous stages that must be updated first');
					return;
				}
			} else if (isSerialized){
				dispatch(actions.setState({submitLastSNToComplete: true}));
			}
		}

		/**
		 * "CurrentTeamAssignedID": null,
                "OriginalTeamAssignedID": null,
                "CurrentTeamAssignedName": "",
		 */

		// if (columnName === 'CurrentAsigneeName') {

		// 	if ((typeof value)==='string' && value.includes('T')) {
		// 		const parsedValue = parseInt(value.slice(1));
		// 		const team = teamsList.find(team => team.TeamCode === parsedValue);

		// 		row['CurrentTeamAssignedID'] = parsedValue;
		// 		row['CurrentTeamAssignedName'] = team.TeamName;
		// 		row['CurrentAsigneeID'] = null;
		// 		row['CurrentAsigneeName'] = '';
		// 	}else{
		// 		const employee = employeeList.filter(emp => emp.empID === value);
		// 		if (employee.length) {
		// 			row['CurrentAsigneeName'] = employee[0].Name;
		// 		}
		// 		row['CurrentAsigneeID'] = value;
		// 		row['CurrentTeamAssignedID'] = null;
		// 		row['CurrentTeamAssignedName'] = '';
		// 	}
		// } else {
		// 	row[columnName] = value;
		// }

		row[columnName] = value;
		let index = rowChangesList.findIndex(changedRow => row.StageID === changedRow.StageID);
		if (index === -1) {
			index = rowChangesList.length;
		}
		
        dispatch(actions.updateStagingRequest(index, row));
	};

	const commitDateRowChanges = async (value, columnName, rowId) => {
		const row = stagesList[rowId];
		const dateResults = await getNewPlannedDueDates(row, value);
		
		for (let i=0; i<dateResults.length; i++) {
			const data = dateResults[i];
			if (data.StageId === -1) {
				dispatch(actions.setState({ newWorkOrderDueDate: data.EndDate }));
			}
			const stageRow = stagesList.filter(stage => stage.StageID === data.StageId)[0];
			
			
			if (stageRow) {
				stageRow['PlannedStartDate'] = dayjs(data.StartDate).format('YYYY-MM-DD');
				stageRow['PlannedDueDate'] = dayjs(data.EndDate).format('YYYY-MM-DD');

	
				let index = rowChangesList.findIndex(changedRow => stageRow.StageID === changedRow.StageID);
				if (index === -1) {
					index = rowChangesList.length + i; // we won't get an updated list
				}
	
				dispatch(actions.updateStagingRequest(index, stageRow));
			} else {
				console.error(`Did not find row for ${data.StageId}, skipping`);
			}
		}

		row[columnName] = value;

		let index = rowChangesList.findIndex(changedRow => row.StageID === changedRow.StageID);
		if (index === -1) {
			index = rowChangesList.length;
		}

		dispatch(actions.updateStagingRequest(index, row));
		// will want this here but it isn't timing out so need to debug first.
		message.success('If planned due date change is saved, all subsequent route stages due dates will be changed as well. View has been updated to reflect these changes.', 5);
	};

	const RowComponent = ({ row, className, ...props }) => {

		// Adds highlight styles to actionable rows
		const snInProcessCountbySummary = getStageInProcessCount(row.StageID);
		let isHighlighted;
		if (snInProcessCountbySummary > 0){
			isHighlighted = true;
		}

        return (
			<Table.Row
				{...props}
				key={props.tableRow.rowId}
				className={clsx(className, {
					'ts_ready': isHighlighted
				})}
			/>
			
        );
    };

	const CellComponent = ({ ...props }) => {
		const { column, row} = props;

		switch(column.name){
			case 'Status':
				return (
					<Table.Cell
						{...props}
					>
						<>
							{
								isSerialized ? (
									getStageInProcessCount(row.StageID) === 1  ? (
									<Select
										size="medium"
										style={{ width: '100%' }}
										defaultValue={row.Status}
										value={row.Status || ''}
										//disabled={((row.OriginalAsigneeID !== loggedEmpId && !teamMemberCheck(teamsList, loggedEmpId, 'T'+row.OriginalTeamAssignedID)) || row.OriginalStatus === 'Complete')}
										onChange={(value) => {
										commitRowChanges(value, column.name, props.tableRow.rowId);
										}}
									>
										{
											statusList.map((status) => {
												return (
													<Select.Option
														key={'modal_'+status.value}
														value={status.value}
													> 
														{status.status}
													</Select.Option>
												);
											})
										}
									</Select>
									) : (
										<span>{row.OriginalStatus}</span>
									)
								) : null
							}
							{
								!isSerialized &&
								<Select
									size="medium"
									className="ts_portal_form_item ts_three_quarter_width"
									style={{ width: '100%' }}
									//disabled={((row.OriginalAsigneeID !== loggedEmpId && !teamMemberCheck(teamsList, loggedEmpId, 'T'+row.OriginalTeamAssignedID)) || row.OriginalStatus === 'Complete')}
									defaultValue={row.Status}
									value={row.Status ? row.Status : ''}
									onChange={(value) => {
										commitRowChanges(value, column.name, props.tableRow.rowId);
									}}
								>
										{
											statusList.map((status) => {
												return (
													<Select.Option
														key={status.value}
														value={status.status}
													> 
														{status.status}
													</Select.Option>
												);
											})
										}
								</Select>

							}
						
						</>
					</Table.Cell>
				);

			// case 'RouteReadyForAssignment': 
			// return (
			// 	<Table.Cell>
			// 		<Popover content={() => <StageInProcessSerialNumberList stageID={row.StageID} />}>
			// 			<span>{getStageInProcessCount(row.StageID)}</span>
			// 		</Popover>
			// 	</Table.Cell>
			// );

			// case 'UpdateSN':
			// 	return (
			// 		<Table.Cell {...props}>
			// 			<Button
			// 				className="ts_portal_button"
			// 				size="medium"
			// 				type="default"
			// 				onClick={() => {
			// 					dispatch(actions.setState({ selectedWODocEntry: row.DocEntry }));
			// 					dispatch(serialNumActions.setState({ currentStageID: row.StageID }));
			// 					dispatch(serialNumActions.setState({ currentTableRowIndex: props.tableRow.rowId }));
			// 					dispatch(serialNumActions.setState({ updateModalOpen: true }));
			// 					dispatch(serialNumActions.setState({ opNum: row.OpNum }));
			// 					dispatch(serialNumActions.setState({ routeName: row.RouteName }));
			// 					dispatch(serialNumActions.setState({ routeDesc: row.Description }));
			// 					dispatch(serialNumActions.setState({ routePrintedDesc: row.PrintedDescription }));
			// 					dispatch(serialNumActions.setState({ routeRev: row.Revision}));
			// 				}}
			// 				disabled={((row.OriginalAsigneeID !== loggedEmpId && !teamMemberCheck(teamsList, loggedEmpId, 'T'+row.OriginalTeamAssignedID)) || row.OriginalStatus === 'Complete')}
			// 			><ArrowRightOutlined /></Button>
			// 		</Table.Cell>
			// 	);

			// case 'RouteCompleted':
			// 	return (
			// 		<Table.Cell>
			// 			<Popover content={() => <StageCompleteSerialNumberList stageID={row.StageID} />}>
			// 				<span>{getStageCompletedCount(row.StageID)}</span>
			// 			</Popover>
			// 		</Table.Cell>
			// 	);

			// case 'CurrentAsigneeName':
			// 	return (
			// 		<Table.Cell {...props}>
			// 		    <Select
			// 				size="medium"
			// 				className="ts_portal_form_item ts_three_quarter_width"
			// 				disabled={((row.OriginalAsigneeID !== loggedEmpId && !teamMemberCheck(teamsList, loggedEmpId, 'T'+row.OriginalTeamAssignedID)) || row.OriginalStatus === 'Complete')}
			// 				defaultValue={
            //                     row.CurrentAsigneeID
            //                     ? row.CurrentAsigneeID
            //                     : row.CurrentTeamAssignedID
            //                       ? 'T'+row.CurrentTeamAssignedID
            //                       : 'None'
            //                 }
			// 				onChange={(value, option) => {
			// 					commitRowChanges(value, column.name, props.tableRow.rowId);
			// 				}}
			// 			>
			// 				<OptGroup label="Group">
			// 					{teamsList.map((team) => {
			// 						return (
			// 							<Option key={'T'+team.TeamCode} value={'T'+team.TeamCode}>
			// 								{team.TeamName}
			// 							</Option>
			// 						)
			// 					})}
			// 				</OptGroup>

			// 				<OptGroup label="Employee">
			// 					{employeeList.map((employee) => (
			// 					<Option key={employee.empID} value={employee.empID}>
			// 						{employee.Name}
			// 					</Option>
			// 					))}
			// 				</OptGroup>

			// 		    </Select>
			// 		</Table.Cell>
			// 	);

			case 'LineNotes':
				return (
					<Table.Cell
						{...props}
					>
							<Popover placement="top" content={row.LineNotes}>
								{/* <p>{row.U_TS_WO_RS_Note}</p> */}
								<span style={{ display: 'inline-block', width: '100%' }}>
									<Input 
										defaultValue={row.LineNotes}
										disabled={row.OriginalStatus === 'Complete'}
										onBlur={(e) => {
											const value = e.target.value;
											commitRowChanges(value, column.name, props.tableRow.rowId);
									}}
								/>
								</span>
							</Popover>
					</Table.Cell>
				);

			case 'DataAsNeeded':
				return (
					<Table.Cell
						{...props}
					>
						<Input 
							defaultValue={row.DataAsNeeded}
							disabled={row.OriginalStatus === 'Complete'}
							onBlur={(e) => {
								const value = e.target.value;
								commitRowChanges(value, column.name, props.tableRow.rowId);
							}}
						/>
					</Table.Cell>
				);

			case 'PlannedStartDate':
				
				return (


					<Table.Cell
						{...props}
					> 
						<DatePicker 
							disabled={true}
							format="MM/DD/YY"
							value={dayjs(row.PlannedStartDate)}
							onChange={(date) => {
								const value = dayjs(date).format('YYYY-MM-DD');
								commitDateRowChanges(value, column.name, props.tableRow.rowId);
							}} 
						/> 
					</Table.Cell>
				);

			case 'PlannedDueDate':
                
				return (


					<Table.Cell
						{...props}
					>
                        <DatePicker 
							disabled={row.OriginalStatus === 'Complete'}
                            format="MM/DD/YY"
                            value={dayjs(row.PlannedDueDate)}
                            onChange={(date) => {
                                const value = dayjs(date).format('YYYY-MM-DD');
                                commitDateRowChanges(value, column.name, props.tableRow.rowId);
                            }}
                        /> 
					</Table.Cell>
				);

			// case 'Attachment':
			// 	return (
			// 		<Table.Cell
			// 			{...props}
			// 		>
			// 			{
			// 				row.Attachment &&
			// 				<a
			// 					href={`${row.Attachment}`}
			// 					target="_blank"
			// 					rel="noreferrer"
			// 				>
			// 					Click to View
			// 				</a>
			// 			}
			// 		</Table.Cell>
			// 	);

			// case 'UploadedAttachment':
			// 	return (
			// 		<Table.Cell
			// 			{...props}
			// 		>
			// 			<Input 
			// 				defaultValue={row.UploadedAttachment ? row.UploadedAttachment : ''}
			// 				onBlur={(e) => {
			// 					const value = e.target.value;
			// 					commitRowChanges(value, column.name, props.tableRow.rowId);
			// 				}}
			// 			/>
			// 		</Table.Cell>
			// 	);

			default: 
				return (
					<Table.Cell
						{...props}
					/>
				);
		}
	};

    return (
		<Card 
			className="ts_portal_card ts-portal-card-margin ts-portal-card-top"
			title="Stages"
		>
			{ 
				saving &&
				<LoadingCover />
			}
			{ 
				loading &&
				<LoadingCover />
			}
			{ 
				loadingWOStage &&
				<LoadingCover />
			}
			<Modal
				open={stageSyncing}
				onCancel={handleClose}
				maskClosable={false}
				closeIcon={false}
				title="Variances found with stages, updating..."
				footer={null}
			>

				<Space direction="vertical" className="ts_full_width ts_padding" size={32}>
					
					<Typography level={4}>
						Once statuses are synced this window will close.
					</Typography>
					
					<Spin tip="syncing..." size="large">
						<div className="ts_container_center"></div>
					</Spin>

				</Space>

			</Modal>
			
			<Grid
				className="ts_max_height_table"
				rows={stagesList}
				columns={stagesTableColumns}
			>

				<SearchState
					onValueChange={setSearchValue}
					value={searchString}
				/>

				<IntegratedFiltering />

				<VirtualTable 
					rowComponent={RowComponent}
					cellComponent={CellComponent}
					columnExtensions={getTableColumnExtensions(stagesTableColumns)}
					
				/>

				<TableHeaderRow/>

				<Toolbar />

				<SearchPanel />
				<div className="ts_all_workorders_task_btn">
					<Button
						className="ts_portal_button_sn_pedigree"
						onClick={() => dispatch(actions.getSNPedigreeFile(docNum))}
					>
						SN Pedigree CSV
					</Button>
					{/* <CopyTableDataToClipboard
						totalRows={stagesList.length}
						tableDataAsList={modifyTableData(stagesTableColumns, stagesList)}
					/> */}
				</div>
			</Grid>

			<Button
                className="ts_margin_top"
				size="large"
				type="default"
				disabled={ rowChangesList.length === 0 || saving }
				onClick={() => {
					dispatch(actions.submitStageChange());
				}}
			>
				SUBMIT TO SAP <CheckOutlined style={{ fontSize: '18px', fontWeight: 'bolder'}} />
			</Button>

			<WorkOrderSNUpdateModal />
		</Card>
    );
};

export default WorkOrderStagesTable;
